import React from 'react';
import {Route} from 'react-router-dom';
import PropTypes from 'prop-types';
import Header from './header/header';

import './landingContainer.scss';
import {UserCenter} from './userCenter/userCenter';
import {PreferenceCenter} from './preference/preferenceCenter';
import SessionTimeout from '../common/components/session/sessionTimeout';
import {ThemeProvider} from '../../../@elixir/theme';

export default class LandingContainer extends React.Component {

    constructor (props) {
        super(props);
    }

    static contextTypes = {
        translator: PropTypes.func.isRequired
    };

    render () {

        return (
            <div className="landingContainer">
                <SessionTimeout/>

                <Header></Header>

                <Route path='/app/user' component={UserCenter}/>
                <Route path='/app/preference' component={PreferenceCenter}/>

            </div>
        );
    }
}

